import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SortTypes } from '../constants/Enums';
@Injectable()
export class HelperService {
  constructor(private messageService: MessageService) {}
  isEmpty(data: any): boolean {
    if (data instanceof Array) {
      return data === null || data === undefined || data.length === 0;
    } else {
      if (data) {
        data = data.toString().trim();
      }
      return data === null || data === undefined || data === '';
    }
  }

  showToaster(status: any, message: string) {
    if (!this.isEmpty(message)) {
      if (status === 'Success') {
        this.messageService.add({
          severity: 'success',
          summary: '',
          detail: message,
        });
      } else if (status === 'Warning') {
        this.messageService.add({
          severity: 'warn',
          summary: '',
          detail: message,
        });
      } else if (status === 'Error') {
        this.messageService.add({
          severity: 'error',
          summary: '',
          detail: message,
        });
      }
    }
  }
  // return the short date
  getCurrentTimeOffSetDate(date: Date): any {
    return new Date(date.getTime() + date.getTimezoneOffset() * -1 * 60000)
      .toJSON()
      .slice(0, 10);
  }

  SortData(data: any[], param: any, operation: string) {
    if (operation == SortTypes.ascending) {
      return data.sort(function (a: any, b: any) {
        if (a[param] > b[param]) {
          return 1;
        } else if (a[param] < b[param]) {
          return -1;
        }
        return 0;
      });
    } else if (operation == SortTypes.descending) {
      return data.sort(function (a: any, b: any) {
        if (a[param] > b[param]) {
          return -1;
        } else if (a[param] < b[param]) {
          return 1;
        }
        return 0;
      });
    }
    return data;
  }

  formatstring(message: string, parmeter: any) {
    var args = parmeter;
    return message.replace(/{([0-9]+)}/g, function (match: any, index: any) {
      return typeof args[index] == 'undefined' ? match : args[index];
    });
  }

  Showfooter(visibility: boolean) {
    const element = document.getElementById('mainfooter');
    if (element) {
      element.style.visibility = visibility == true ? 'visible' : 'hidden';
    }
  }
}
